export const createHitboxPath = ({
  primaryNavItemRef,
  secondaryMenuRef
}) => {
  if (!primaryNavItemRef.current || !secondaryMenuRef) {
    return '';
  }
  const primaryNavItemRect = primaryNavItemRef.current.getBoundingClientRect();
  const secondaryNavItemRect = secondaryMenuRef.getBoundingClientRect();
  return `
    M ${primaryNavItemRect.x} ${primaryNavItemRect.y}
    Q ${secondaryNavItemRect.x} ${primaryNavItemRect.y},
      ${secondaryNavItemRect.x} ${secondaryNavItemRect.y}
    v ${Math.max(primaryNavItemRect.height, secondaryNavItemRect.height)}
    Q ${secondaryNavItemRect.x} ${primaryNavItemRect.y + primaryNavItemRect.height},
      ${primaryNavItemRect.x} ${primaryNavItemRect.y + primaryNavItemRect.height}
    h ${primaryNavItemRect.width}
    v ${-primaryNavItemRect.height}
    z
  `;
};
export const defaultHitboxStyles = {
  width: '0',
  height: '0'
};
export const getHitboxStyles = ({
  primaryNavItemRef,
  secondaryMenuRef
}) => {
  if (!primaryNavItemRef.current || !secondaryMenuRef) {
    return defaultHitboxStyles;
  }
  const primaryNavItemRect = primaryNavItemRef.current.getBoundingClientRect();
  const secondaryNavItemRect = secondaryMenuRef.getBoundingClientRect();
  return {
    width: `${secondaryNavItemRect.right}px`,
    height: `${Math.max(primaryNavItemRect.bottom, secondaryNavItemRect.bottom)}px`
  };
};